import { NotificationService } from "../_services/notification.service";

export const notificationAction = {
  getPreventiveActionsByDateAndId,
  preventiveActionNotification,
  cityWisePreventiveActionNotification,
  distinctPreventiveActionNotification,
  countPreventiveNotification,
  getPreventiveActionsNotSendNotification,
  cityWisePreventiveActionNotificationCount,
  distinctPreventiveActionNotificationCount,
  getPreventiveActionsNotSendNotificationCount,
  getPreventiveActionsNotSendNotificationDistictWise,
  updateInformation,
  districtWiseCountPreventiveNotification,
};
function getPreventiveActionsByDateAndId(values) {
  return NotificationService.getPreventiveActionsByDateAndId(values);
}
function preventiveActionNotification(values) {
  return NotificationService.preventiveActionNotification(values);
}
function cityWisePreventiveActionNotification(values) {
  return NotificationService.cityWisePreventiveActionNotification(values);
}
function distinctPreventiveActionNotification(values) {
  return NotificationService.distinctPreventiveActionNotification(values);
}
function countPreventiveNotification(values) {
  return NotificationService.countPreventiveNotification(values);
}
function getPreventiveActionsNotSendNotification(values) {
  return NotificationService.getPreventiveActionsNotSendNotification(values);
}
function cityWisePreventiveActionNotificationCount(values) {
  return NotificationService.cityWisePreventiveActionNotificationCount(values);
}
function distinctPreventiveActionNotificationCount(values) {
  return NotificationService.distinctPreventiveActionNotificationCount(values);
}
function getPreventiveActionsNotSendNotificationCount(values) {
  return NotificationService.getPreventiveActionsNotSendNotificationCount(
    values
  );
}
function getPreventiveActionsNotSendNotificationDistictWise(values) {
  return NotificationService.getPreventiveActionsNotSendNotificationDistictWise(
    values
  );
  
}
function updateInformation(values) {
  return NotificationService.updateInformation(values);
}
function districtWiseCountPreventiveNotification(values) {
  return NotificationService.districtWiseCountPreventiveNotification(values);
}